@if (showHeader) {
    <app-header [showMenu]="true"></app-header>
}
@if (showBack) {
    <a mat-button class="goBack fade-in" (click)="goBack()">
        <mat-icon>keyboard_arrow_left</mat-icon>
        {{ 'account.back' | transloco }}
    </a>
}
<br/>
<!--<app-video-link *ngIf="showHeader" class="pull-right" videoLink="/help/download"></app-video-link>-->
<span style="padding: 30px; font-size: 2em">
  <mat-icon style="position: relative; top: 5px">download</mat-icon>
    {{ headerText1 }}
</span>
<br/>
<span style="padding: 30px; font-size: 1em">
  {{ headerText2 }}
</span>
<br/>
<br/>
@if (showPlayer) {
    <div fxLayout="row" fxFill class="contButtons">
        <button fxFlex="100%" (click)="go('0')" class="goBack" mat-raised-button>
            <fa-icon size="1x" class="clBlue" [icon]="faEdit"></fa-icon>
            <span class="switchButtons clBlue">{{ 'account.studio' | transloco }}</span>
        </button>
        <button fxFlex="100%" (click)="go('1')" class="goBack" mat-raised-button>
            <fa-icon size="1x" class="clBlue" [icon]="faTv"></fa-icon>
            <span class="switchButtons clBlue">{{ 'account.player' | transloco }}</span>
        </button>
    </div>
}
<ngx-flicking [options]="{ circular: false, duration: 800, autoResize: true }" [plugins]="plugins">
    <div flicking-panel class="panel">
        <br/>
        <br/>
        <app-studio-download></app-studio-download>
    </div>
    <div flicking-panel class="panel">
        <br/>
        <br/>
        <div class="form-main">
            <ul>
                <span class="minHead">1. Get the Digital Signage & Touch Player</span>
                <div style="text-align: left">
                    <br/>
                    <button mat-raised-button class="downloadMainBut" (click)="download('player_sign_chrome')">
                        <fa-icon size='lg' class="web" [icon]="faTv"></fa-icon>
                        <span style="font-size: 1.4em">Download SignPlayer | all OS</span>
                    </button>
                </div>
                <div>
                    <div class="os-info-text" style="opacity: 0.7">
                        <br/>
                        <a (click)="download('mediadroid')" mat-button style="text-align: left">
                            <mat-icon style="font-size: 1.5em; width: 37px !important; color: #7dee00">router</mat-icon>
                            For the best performance, Plug & Play Signage/touch player, get the mediaDROID+
                        </a>
                        <br/>
                        <br/>
                        <a (click)="download('device_compatability')" mat-button style="text-align: left">
                            <!--                            <mat-icon style="font-size: 1.5em; width: 30px !important; color: #7dee00">star_border</mat-icon>-->
                            <fa-icon size='lg' class="watchdog" [icon]="faAndroid"></fa-icon>
                            For Google TV and Fire TV
                        </a>
                        <br/>
                    </div>
                </div>
                <br/>
                <span class="minHead">2. Get the SignService (auto starts, monitors and restarts player)</span>
                <br/>
                <br/>
                <a (click)="download('player_android_sign_watchdog')" mat-button style="text-align: left">
                    <fa-icon size='lg' class="watchdog" [icon]="faAndroid"></fa-icon>
                    For Android for SignPlayer PWA
                </a>
                <a (click)="download('player_windows_sign_watchdog')" mat-button style="text-align: left">
                    <fa-icon size='lg' class="microsoft" [icon]="faMicrosoft"></fa-icon>
                    For Windows for SignPlayer PWA
                </a>
                <br/>
                <div class="info-note">
                    <small>💡 <strong>NOTE:</strong> Download link for SignService is also available from within the player's Info Box by clicking the Gear icon of the Player's Sidebar.</small>
                </div>
                <br/>
                <a (click)="download('player_linux_sign_watchdog')" mat-button style="text-align: left">
                    <fa-icon size='lg' class="linux" [icon]="faLinux"></fa-icon>
                    For Linux / Ubuntu for SignPlayer PWA (to be released)
                </a>
                <!--                <li>-->
                <!--                    <mat-label (click)="download('')" class="itemText"><span class="downloadable "></span>-->
                <!--                        <br/>-->
                <!--                        <div class="os-info-text">for all mediaDROID+ ordered starting January 2023 onwards</div>-->
                <!--                        <div class="os-info-text">also for some generic Android 9.X OS</div>-->
                <!--                    </mat-label>-->
                <!--                </li>-->
                <br/>
                <br/>
                <br/>

                <mat-accordion>
                    <!-- #docregion basic-panel -->
                    <!-- #docregion hide-toggle -->
                    <mat-expansion-panel hideToggle>
                        <p>This is the primary content of the panel.</p>
                    </mat-expansion-panel>
                    <!-- #enddocregion basic-panel -->
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span class="minHead">Deprecated | previous version</span>
                            </mat-panel-title>
                            <mat-panel-description>
                                <!--                                Currently I am {{panelOpenState ? 'open' : 'closed'}}-->
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        get the previous version of the SignagePlayer AIR
                        <br/>
                        <br/>
                        <div>
                            <li>
                                <fa-icon size='lg' class="microsoft" [icon]="faMicrosoft"></fa-icon>
                                <mat-label (click)="download('player_exe')" class="itemText"><span class="downloadable ">SignagePlayer.exe (legacy only)</span><br/>
                                    <div class="os-info-text">Dedicated Desktop edition | Microsoft Windows (32/64 bit)</div>
                                </mat-label>
                            </li>
<!--                            <li>-->
<!--                                <fa-icon size='lg' class="android" [icon]="faAndroid"></fa-icon>-->
<!--                                <mat-label (click)="download('player_apk')" class="itemText"><span class="downloadable ">SignagePlayer.apk v6.3 (legacy only)</span>-->
<!--                                    <br/>-->
<!--                                    <div class="os-info-text">Dedicated Mobile edition | Android</div>-->
<!--                                </mat-label>-->
<!--                            </li>-->
                            <li>
                                <fa-icon size='lg' class="android" [icon]="faAndroid"></fa-icon>
                                <mat-label (click)="download('player_legacy_apk')" class="itemText"><span class="downloadable ">SignagePlayer.apk v1 (legacy only)</span>
                                    <br/>
                                    <div class="os-info-text">Legacy ADX and older Android players prior to Android 9.x</div>
                                </mat-label>
                            </li>
                            <li>
                                <fa-icon size='lg' class="watchdog" [icon]="faAndroid"></fa-icon>
                                <mat-label (click)="download('player_android_watchdog_v2')" class="itemText"><span class="downloadable ">Android Watchdog SignagePlayer apk (v2)</span>
                                    <br/>
                                    <div class="os-info-text">for ADZ and Android 9.X and later</div>
                                </mat-label>
                            </li>
<!--                            <li>-->
<!--                                <fa-icon size='lg' class="android" [icon]="faGooglePlay"></fa-icon>-->
<!--                                <mat-label (click)="download('player_apk_store')" class="itemText"><span class="downloadable ">SignagePlayer.apk (older version v4.1)</span><br/>-->
<!--                                    <div class="os-info-text">Mobile edition | Android 4.4+ | Updates from the Google store</div>-->
<!--                                </mat-label>-->
<!--                            </li>-->
                            <li>
                                <fa-icon size='lg' class="watchdog" [icon]="faAndroid"></fa-icon>
                                <mat-label (click)="download('player_android_watchdog_v1')" class="itemText"><span class="downloadable ">Android Watchdog apk (v1)</span>
                                    <br/>
                                    <div class="os-info-text">for legacy SignagePlayer / ADX and older Android players</div>
                                </mat-label>
                            </li>
                            <li>
                                <fa-icon size='lg' class="apple" [icon]="faBolt"></fa-icon>
                                <fa-icon size='lg' class="adobe" [icon]="faBolt"></fa-icon>
                                <mat-label class="itemText">
                                    <span (click)="download('player_air')" class="downloadable ">SignagePlayer.air </span>
                                    <span (click)="download('player_air_dmg')" class="downloadable ">| requires AIR installer</span>
                                    <br/>
                                    <div class="os-info-text">Desktop edition | Mac OSX (32 bit)</div>
                                    <br/>
                                </mat-label>
                            </li>
                            <li>
                                <fa-icon size='lg' class="microsoft" [icon]="faMicrosoft"></fa-icon>
                                <fa-icon size='lg' class="adobe" [icon]="faBolt"></fa-icon>
                                <mat-label class="itemText">
                                    <span (click)="download('player_air')" class="downloadable ">Get SignagePlayer.air </span>
                                    <span (click)="download('player_air_exe')" class="downloadable ">| requires AIR installer</span>
                                    <br/>
                                    <div class="os-info-text">Desktop edition | Microsoft Windows (32/64 bit)</div>
                                    <br/>
                                </mat-label>
                            </li>
                            <li>
                                <fa-icon size='lg' class="linux" [icon]="faLinux"></fa-icon>
                                <mat-label class="itemText">
                                    <span (click)="download('player_linux')" class="downloadable ">Get SignagePlayer for Linux</span>
                                    <br/>
                                    <div class="os-info-text">deprecated | limited support</div>
                                </mat-label>
                            </li>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </ul>
            <br/>
            <br/>
            <br/>
            <br/>
        </div>
    </div>
</ngx-flicking>
<ng-template let-modal #installModal>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <mat-icon class="moveMatIcon">fact_check</mat-icon>
        <mat-label>Manual installation for Android</mat-label>
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content>
        <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-raised-button (click)="download('mediadroid')" style="padding: 10px; margin: 20px; width: 100%" color="warn">
                <mat-icon class="hide-lt-md">star</mat-icon>
                for best performance & reliability get the mediaDROID+
            </button>
        </div>
        <div class="compat">
            <div>
                <div>
                    <br/>
                    <mat-label class="minHead">🚀 Direct installation of SignPlayer on Android with no Preinstalled Chrome on the device such as Google TV and Fire TV</mat-label>
                    <hr/>
                    <div class="installation-steps">
                        <ol style="line-height: 1.8; margin: 20px 0;">
                            <li>
                                📱 Download and install Chrome from <a href="https://play.google.com/store/apps/details?id=com.android.chrome" target="_blank" class="linkGoToDownload hover-link">Google Play Store</a> or get the APK from <a href="https://www.apkmirror.com/apk/google-inc/chrome/" target="_blank" class="linkGoToDownload hover-link">https://www.apkmirror.com/apk/google-inc/chrome/</a>.
                                <br/><small style="opacity: 0.8;">Make sure to choose arm64-v8a + armeabi-v7a architecture and its an APK and not BUNDLE<br/>
                                (Last tested on Google Chrome 138.0.7204.168 (arm64-v8a + arm-v7a) (Android 8.0+))</small>
                            </li>
                            <li>
                                ⬇️ Download and install SignService from <a href="https://galaxy.signage.me/deploy/android/signService.apk" target="_blank" class="linkGoToDownload hover-link">https://galaxy.signage.me/deploy/android/signService.apk</a>
                            </li>
                            <li>
                                ✅ On launch, click each check list item's Allow button to enable permissions.<br/>
                                <small style="opacity: 0.8;">Note that not all permissions is available on all devices - check the Dialog box and see Note if said permission is applicable for the device you are installing.</small>
                            </li>
                            <li>
                                🌐 When done, click Start SignPlayer - Chrome will open and will show the install page. If you are asked which App to use and SignPlayer is not in the selection, choose Chrome then click Just Once.
                            </li>
                            <li>
                                📺 For Google TV and Fire TV, using the mouse, click on the SignPlayer link - this will install SignPlayer.
                            </li>
                            <li>
                                🔄 After SignPlayer is installed, restart the device.
                            </li>
                            <li>
                                🎯 On boot, SignService will kick and may ask which App to launch. Choose SignPlayer and this time choose Always.
                            </li>
                            <li>
                                ✨ Installation is complete. Register your player if you have not yet done so.
                            </li>
                        </ol>
                    </div>
                    <br/>
                </div>
            </div>
<!--            <div>-->
<!--                <fa-icon style="position:relative; top: 4px" size='lg' class="watchdog" [icon]="faAndroid"></fa-icon>-->
<!--                <span class="minHead">SignPlayer and watchdog are also compatible these Android devices:</span>-->
<!--                <hr/>-->
<!--                <ul class="">-->
<!--                    <li>Google TV</li>-->
<!--                    <li>Fire TV</li>-->
<!--                    <li>Android TV</li>-->
<!--                    <li>Android Car</li>-->
<!--                    <li>Google Chrome OS Flex</li>-->
<!--                    <li>Google Chromecast</li>-->
<!--                    <li>Microsoft Windows (latest)</li>-->
<!--                    <li>Apple Mac</li>-->
<!--                    <li>Linux (Ubuntu tested)</li>-->
<!--                    <li>Amazon Fire stick</li>-->
<!--                    <li>TCL TV</li>-->
<!--                    <li>Sony Bravia TV</li>-->
<!--                    <li>Samsung Android TV</li>-->
<!--                    <li>Nvidia Shield (latest)</li>-->
<!--                    <li>Raspberry PI</li>-->
<!--                    <li>iPad (check version with support)</li>-->
<!--                    <li>iPhone (check version with support)</li>-->
<!--                    <li>Browser / Web embedded</li>-->
<!--                </ul>-->
<!--            </div>-->
        </div>
    </div>
</ng-template>
